module.exports = "https://cdn-static.article.com/storefront/55923f29a92e3bb8986a23870f0b41133f601889/dist/static/images/favicons/apple-touch-icon-180x180.png";